import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    const configs = {
      design: {
        label: 'Design',
        className: 'status-badge status-design',
      },
      approved: {
        label: 'Approved',
        className: 'status-badge status-approved',
      },
      printed: {
        label: 'Printed',
        className: 'status-badge status-printed',
      },
      ready_for_collection: {
        label: 'Ready for Collection',
        className: 'status-badge status-ready',
      },
      collected: {
        label: 'Collected',
        className: 'status-badge status-collected',
      },
    };

    return configs[status] || {
      label: status,
      className: 'status-badge bg-gray-100 text-gray-800',
    };
  };

  const config = getStatusConfig(status);

  return (
    <span className={config.className}>
      {config.label}
    </span>
  );
};

export default StatusBadge; 